import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@massilia/ui';
import { Input } from '@massilia/ui';
import { Label } from '@massilia/ui';
import { Slider } from '@massilia/ui';
import { useCallback } from 'react';
import { useFieldContext } from '../hooks/use-app-form.js';
import { FieldError } from './field-error';
const STABLE_OBJECT = {};
export default function RangeField({ className, boundsMax, boundsMin, label, step = 1, unit = '', }) {
    const field = useFieldContext();
    const errors = field.state.meta.errors;
    const value = field.state.value ?? STABLE_OBJECT;
    const currentMin = value.min ?? boundsMin;
    const currentMax = value.max ?? boundsMax;
    const handleMinChange = useCallback((rawValue) => {
        const parsed = Number.parseFloat(rawValue);
        if (rawValue === '' || Number.isNaN(parsed)) {
            field.handleChange({ ...value, min: undefined });
            return;
        }
        field.handleChange({ ...value, min: parsed });
    }, [value, field]);
    const handleMaxChange = useCallback((rawValue) => {
        const parsed = Number.parseFloat(rawValue);
        if (rawValue === '' || Number.isNaN(parsed)) {
            field.handleChange({ ...value, max: undefined });
            return;
        }
        field.handleChange({ ...value, max: parsed });
    }, [value, field]);
    const handleSliderChange = useCallback((sliderValues) => {
        const [newMin, newMax] = sliderValues;
        field.handleChange({
            max: newMax === boundsMax ? undefined : newMax,
            min: newMin === boundsMin ? undefined : newMin,
        });
    }, [boundsMin, boundsMax, field]);
    return (_jsxs("div", { className: cn('flex flex-1 flex-col gap-2', className), children: [label && _jsx(Label, { className: "text-sm font-medium md:text-[16px]", children: label }), _jsxs("div", { className: "flex items-center gap-3", children: [_jsxs("div", { className: "flex flex-1 flex-col gap-1", children: [_jsx("span", { className: "text-xs text-gray-500", children: "Min" }), _jsxs("div", { className: "relative", children: [_jsx(Input, { className: "pr-8", inputMode: "numeric", onBlur: field.handleBlur, onChange: (e) => {
                                            handleMinChange(e.target.value);
                                        }, placeholder: boundsMin.toString(), type: "number", value: value.min ?? '' }), unit && (_jsx("span", { className: "pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-sm text-gray-400", children: unit }))] })] }), _jsx("span", { className: "mt-5 text-gray-400", children: "-" }), _jsxs("div", { className: "flex flex-1 flex-col gap-1", children: [_jsx("span", { className: "text-xs text-gray-500", children: "Max" }), _jsxs("div", { className: "relative", children: [_jsx(Input, { className: "pr-8", inputMode: "numeric", onBlur: field.handleBlur, onChange: (e) => {
                                            handleMaxChange(e.target.value);
                                        }, placeholder: boundsMax.toString(), type: "number", value: value.max ?? '' }), unit && (_jsx("span", { className: "pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-sm text-gray-400", children: unit }))] })] })] }), _jsx(Slider, { max: boundsMax, min: boundsMin, onValueChange: handleSliderChange, step: step, value: [currentMin, currentMax] }), _jsx(FieldError, { errors: errors })] }));
}
